import { connect } from 'react-redux';
import { getExperienceDetailsData } from '@yme/api';
import { setPageProperties as setPagePropertiesAction } from '@yme/common/redux/common/action';
import BaseDetailsPage from '@yme/components/Destinations/components/BaseDetailsPage';
import { buildRequestUrl } from '@yme/organisms/product-carousel/helpers';
import { getPDPLinks } from '@yme/selectors/common';
import { Network } from '@yme/services/network';
import { DigitalDataMutation } from '@yme/utils/common';
import { EXPERIENCE_BY_PATH_ENDPOINT } from './constants';
import { getDestinationAnalyticsData, mapImageData } from './helpers';
import { setExperienceDetailsData, setExperienceDetailsDataLoaded, setInitialExperienceDetailsData, setRelatedUnitsData, } from './redux/actions';
class ExperienceDetailsPage extends BaseDetailsPage {
    fetchDetailsData() {
        getExperienceDetailsData(`${EXPERIENCE_BY_PATH_ENDPOINT}${this.props.destinationEntityId}`).then(async ({ data, imageData }) => {
            const mappedData = {
                ...mapImageData(data, imageData),
                edpPath: this.props.edpPath,
            };
            this.props.setExperienceDetails(mappedData);
            this.props.setExperienceDetailsDataLoaded(true);
            const units = [];
            const filteredUnits = mappedData?.units?.filter((unit) => unit) ?? [];
            if (this.props.hyperdriveEndpoint && filteredUnits.length) {
                try {
                    const cards = filteredUnits?.map((unit) => ({
                        slug: unit,
                    }));
                    const answer = await Network.get(buildRequestUrl(this.props.hyperdriveEndpoint, cards));
                    this.props.setRelatedUnits(answer.data.results);
                    units.push(...answer.data.results);
                }
                catch (error) {
                    this.props.setExperienceDetailsDataLoaded(true);
                }
            }
            const analyticsData = getDestinationAnalyticsData(mappedData, units, this.props.pdpLinks);
            this.setAnalyticsData(DigitalDataMutation.EDP_VIEW, analyticsData, 'destination');
        });
    }
    setInitialData() {
        this.props.setInitialExperienceDetails();
    }
}
// TODO: Astrouski - fix types and remove any
const mapStateToProps = (state) => ({
    pdpLinks: getPDPLinks(state),
});
export default connect(mapStateToProps, {
    setPageProperties: setPagePropertiesAction,
    setRelatedUnits: setRelatedUnitsData,
    setExperienceDetails: setExperienceDetailsData,
    setInitialExperienceDetails: setInitialExperienceDetailsData,
    setExperienceDetailsDataLoaded,
})(ExperienceDetailsPage);
